// Vendor libraries
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
// Ngrx reducers
import { getLogger } from 'NewAngular/state/logger';
// Module imports
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
// Component imports
import { BrowseIndexFamiliesPageComponent } from 'IndicesApp/ts/apps/index-families-app/components/browse-index-families-page/browse-index-families-page.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ngrx/store";
export class AppModule {
}
AppModule.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(); };
AppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule, bootstrap: [TopBarNavComponent, BrowseIndexFamiliesPageComponent] });
AppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [{ provide: APP_BASE_HREF, useValue: '/' }], imports: [BaseAutocompleteModule,
        BrowserModule,
        ConfigModule,
        NavigationModule,
        RouterModule.forRoot([
            { path: 'indices/families', component: BrowseIndexFamiliesPageComponent },
            { path: '', redirectTo: 'indices/families', pathMatch: 'full' },
        ], {
            anchorScrolling: 'enabled',
        }),
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
